import React from 'react';

import FunctionalTableComponent from '../table/FunctionalTableComponent';
import columns from './GlobalConfigTableConfig';
import { fields } from './GlobalConfigFormConfig';
import { useGlobalConfig } from './GlobalConfigContext';

const GlobalConfigComponent = ({ setLoader }) => {
  function editionFields(editionItem) {
    return fields(editionItem?.type, editionItem.label);
  }

  const { contextUpdated } = useGlobalConfig();

  return (
    <>
      <FunctionalTableComponent
        className={'mt-5'}
        title={'Lista zmiennych'}
        columns={columns}
        header={true}
        api={'globalConfig'}
        setLoader={setLoader}
        removable={false}
        editable={true}
        width={12}
        shadow={false}
        tableHeader={false}
        pagination={false}
        editWithPost={true}
        modalSize={"lg"}
        editionFields={editionFields}
        onCreated={contextUpdated}
      />
    </>
  );
};

export default GlobalConfigComponent;
